<template>
  <amplify-authenticator>
    <div class="wrapper">
      <!-- 入力フォーム -->
      <div class="input_form">
        <div class="group">
          <select id="area" v-model="selected.area" @change="onSelected()">
            <option v-for="area in AREAS" v-bind:value="area.value" v-bind:key="area.value">{{ area.text }}</option>
          </select>
        </div>
        <div class="group">
          <div class="block left">
            <div class="choice" :class="{checked: selected.distOrCompany == 'dist'}">
              <input id="distribution" class="radio" name="distribution" type="radio" value="dist" v-model="selected.distOrCompany" @change="onSelected()" :disabled="!isSelectedArea" />
              <label for="distribution">ENTER<br>DISTRIBUTION</label>
            </div>
          </div>
          <div class="block">
            <select id="distcode" v-model="selected.distcode" :disabled="!isSelectedDistCode">
              <option value="" disabled selected style="display:none;">DISTCODE</option>
              <option v-for="distcode in distcodes" v-bind:value="distcode.value" v-bind:key="distcode.value">{{ distcode.value }}</option>
            </select>
            <input class="margin_top" type="text" id="distname" name="distname" :value="distname" placeholder="DISTNAME" readonly disabled />
          </div>
        </div>
        <div class="group">
          <div class="block left">
            <div class="choice" :class="{checked: selected.distOrCompany == 'company'}">
              <input id="company" class="radio" name="company" type="radio" value="company" v-model="selected.distOrCompany" @change="onSelected()" :disabled="!isSelectedArea" />
              <label for="company" class="company">ENTER<br>COMPANY</label>
            </div>
          </div>
          <div class="block">
            <input type="text" id="companycode" name="companycode" v-model="selected.companycode" :disabled="isSelectedDistCode" maxlength="10" placeholder="COMPANYCODE" />
            <input class="margin_top" type="text" id="companyname" name="companyname" v-model="selected.companyname" :disabled="isSelectedDistCode" maxlength="50" placeholder="COMPANYNAME" />
          </div>
        </div>
      </div>
      
      <!-- QR入力フォーム -->
      <div class="manual_enrty_form">
         <textarea id="qrtxt" name="qrtxt" minlength="122" maxlength="122" v-model="qrtxt" style="resize: none; width: 100%;" placeholder="◢◤QR INFO Manual Entry Form◢◤
Scan the QR with your camera app, then paste it into this form."></textarea>
      </div>
      
      <!-- バーコード読み取り結果 -->
      <div class="scan_result">
        <label>QR INFO:</label>
        <p style="width: 100%; white-space:pre-wrap; word-wrap: break-word;">{{ scanResult }}</p>
      </div>
      
      <!-- 各種ボタン -->
      <div class="btn_group">
        <img class="camera" src="/image/camera_off.png" alt="CAMERA OFF" v-if="enabledCamera" @click="onSwitchCamera">
        <img class="camera" src="/image/camera_on.png" alt="CAMERA ON" v-if="!enabledCamera" @click="onSwitchCamera">
        <button class="clear" @click="onScanClear">SCAN DATA CLEAR</button>
        <button class="send" @click='onSend'>SEND</button>
      </div>
      
      <!-- 送信結果 -->
      <div class="send_result">
        <p>{{ sendResult }}</p>
      </div>
      
      <!-- バーコードカメラ -->
      <div class="scan_camera">
        <StreamBarcodeReader @decode="onDecode" @loaded="onLoaded()" v-if="enabledCamera" />
      </div>
    </div>
    
    <br />
  <amplify-sign-up slot="sign-up"
    username-alias="email"
    :form-fields.prop="formFields"
  ></amplify-sign-up>
  <amplify-sign-out></amplify-sign-out>
    
    <div class="copyright">
      <small>Copyright (c) Toyota Motor Corporation All rights reserved.</small>
    </div>
  </amplify-authenticator>
</template>

<script>
import { StreamBarcodeReader } from "vue-barcode-reader";
import { API, Auth } from "aws-amplify";
import { onAuthUIStateChange } from '@aws-amplify/ui-components';

export default {
  name: "App",
  components: {
    StreamBarcodeReader,
  },
  data() {
    return {
      key: null,
      selected: null,
      scanResult: "not scanning",
      sendResult: "",
      enabledCamera: false,
      formFields: [
        { type: "email" },
        { type: "password" },
     ]
    };
  },
  created() {
    this.selected = this.DATA_FORMAT;
    const self = this;
    this.unsubscribeAuth = onAuthUIStateChange((authState, authData) => {
      if (authState === "signedout") {
        self.enabledCamera = false;
        self.save(self.key, self.selected);
        self.unsubscribeAuth();
      } else {
        if (authData) {
          self.key = authData.username;
          self.selected = self.load(self.key);
        }
      }
    })
  },
  mounted() {
    const self = this;
    window.addEventListener('beforeunload', () => {
      self.save(self.key, self.selected);
      self.unsubscribeAuth();
    });
  },
  computed: {
    isSelectedArea() {
      return this.selected.area !== "";
    },
    isSelectedDistCode() {
      return this.isSelectedArea && this.selected.distOrCompany === "dist";
    },
    distcodes() {
      if (!this.isSelectedDistCode) return [];
      return this.AREAS.find(x => x.value === this.selected.area).children;
    },
    distname() {
      if (!this.isSelectedDistCode || this.selected.distcode === "") return "";
      return this.distcodes.find(x => x.value === this.selected.distcode).text;
    }
  },
  methods: {
    onSelected() {
      this.selected.distcode = "";
      this.selected.companycode = "";
      this.selected.companyname = "";
      document.getElementById("qrtxt").value = "";
      this.qrtxt= "";
    },
    onSwitchCamera() {
      this.enabledCamera = !this.enabledCamera;
      this.scanResult = "not scanning";
      this.sendResult = "";
      this.result= '';
      document.getElementById("qrtxt").value = "";
      this.qrtxt= "";
    },
    onDecode (result) {
      if("-" === result.substring(0,1)){
        this.scanResult = result;
        this.sendResult = "Please press the send button.";
      document.getElementById("qrtxt").value = "";
      this.qrtxt= "";
      }
    },
    onLoaded() {},
    onScanClear() {
      this.scanResult = "not scanning";
      this.sendResult = "";
      this.result= '';
      document.getElementById("qrtxt").value = "";
      this.qrtxt= "";
      this.enabledCamera = false;  
    },
    async onSend() {
      try {
        // COUNTRYNAME入力チェック
        if (!this.isSelectedArea) {
          throw 'Required field!';
        }
        // DISTCODE入力チェック(COMPANYCODEとCOMPANYNAMEは未入力許容)
        if (this.isSelectedDistCode) {
          if (this.selected.distcode === "") {
            throw 'Required field!';
          }
        }
        // 手入力値(122文字)ありの場合、手入力値を読み取り結果とする
        if(this.qrtxt.length == 122) {
          this.scanResult = this.qrtxt;
        }
        // 読み取り結果の値判定(先頭が「-」でない場合は無効値)
        if (this.scanResult.substring(0,1) !== "-") {
          throw 'Parameter is not a number!';
        }
        
        // データ送信用のトークン取得
        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;
        // 送信データ準備
        const dist = { "code" : this.selected.distcode, "name" : this.distname };
        const country = { "name" : this.selected.area, dist };
        const company = { "code" : this.selected.companycode, "name" : this.selected.companyname };
        const affiliation = { country, company, "qr_info" : this.scanResult };
        const json = JSON.stringify(affiliation);
        // console.log(JSON.stringify(affiliation));
        // データ送信
        const header = { headers: { Authorization: token }, body: JSON.parse(json) };
        const res = await API.post('v1', '/parts', header);
        console.log(JSON.stringify(res));
        this.sendResult = "Data sent successfully.";
        this.scanResult = "not scanning";
        this.result= '';
        document.getElementById("qrtxt").value = "";
        this.qrtxt= "";
        this.enabledCamera = false;
      } catch(e) {
        console.log(JSON.stringify(e));
        this.sendResult = "Request failed. Please check your entries or scan result.";
        this.enabledCamera = false;
      }
    }
  }
};
</script>

<style scoped>
/* 全体設定 */
*, ::before, ::after {
  box-sizing: border-box;
  font-family: consolas;
}
.wrapper {
  font-family: consolas;
  font-size: 14px;
  color: #2c3e50;
}

/* 入力フォーム */
.input_form .margin_top {
  margin-top: 4px;
}
.input_form {
  padding: 4px 20px;
}
.input_form .group {
  display: flex;
  align-items: center;
  margin-top: 8px;
}
.input_form .group .block + .block {
  margin-left: 8px;
  width: 100%;
}
.input_form .group .block.left {
  width: 30%;
}
.input_form .group .choice {
  display: flex;
  align-items: center;
  height: 56px;
  font-size: 14px;
  color: white;
  background: gray;
}
.input_form .group .choice input {
  width: 20px;
  height: 20px;
  margin: 0px;
}
.input_form .group .choice label {
  text-align: center;
  color: white;
  font-weight: bold;
}
.input_form .group .choice.checked {
  background: #ff9900;
}
.input_form label {
  display: inline-block;
  width: 140px;
}
.input_form select, .input_form input {
  width: 100%;
  height: 26px;
  font-size: 14px;
}
#distname {
  border: none;
  background: transparent;
}

/* QR入力フォーム */
.manual_enrty_form {
  padding: 4px 20px;
  box-sizing: border-box;
}

/* バーコード読み取り結果 */
.scan_result {
  padding: 4px 20px;
}
.scan_result p {
  margin: 0;
  color: #7f7fff;
  font-size: 12px;
}

/* 各種ボタン */
.btn_group {
  padding: 8px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.btn_group button {
  width: 40%;
  height: 32px;
  padding: 8px 0px;
  border: 0;
  color: white;
  font-weight: bold;
}
.btn_group .clear {
  background: #ff9900;
}
.btn_group .send {
  background: #ff9900;
}

/* 送信結果 */
.send_result {
  padding: 4px 20px;
  color: red;
}
.send_result p {
  margin: 0;
}

/* カメラ */
.scan_camera {
  margin: 0 auto;
  width: 80%;
  height: 40%;
}

/* コピーライト */
.copyright {
  text-align: center;
  color: #808080;
}
</style>